<template>
  <div class="card container h-100">
    <div v-if="experience !== undefined" :identifier="experience.identifier" class="card-body">
      <h2>{{ $t(`${experience.identifier}_title`) }}</h2>
      <div class="container p-0">
        <div class="row">
          <div v-if="presentation != 'description'" class="col-md-6 p-0">
            <div v-for="(p, k, i) in presentation" :key="p">
              <label> {{ k }}</label>
              <video-player title="Video of Presentation"

             :src="`${p}`"

             type="video/mp4"/></video-player>

            </div>
          </div>
          <div v-else class="col-md-6 col-sm-12">
            <img
              class="product-image rounded colored-shadow"
              :src="
                `${IREALCONFIG.static_ressources}/labs/${experience.identifier}/${experience.identifier}_poster.jpg`
              "
              alt="poster"
            />
          </div>

          <div class="col-md-6 col-sm-12">
            <div class="row h-100 ml-3">
              <div>
                <p v-html="$t(`${experience.identifier}_description`)" class="row col-12 text-justify">
                  {{ $t(`${experience.identifier}_description`) }}
                </p>
                <table class="col-12 credits">
                  <tr>
                    <th>
                      <b> {{ $t("experiment_owner") }}</b>
                    </th>
                    <td class="pl-3">{{ experience.owner }}</td>
                  </tr>
                  <tr>
                    <th>
                      <b> {{ $t("experiment_designer") }}</b>
                    </th>
                    <td class="pl-3">{{ experience.designer }}</td>
                  </tr>
                  <tr>
                    <th>
                      <b> {{ $t("experiment_operator") }}</b>
                    </th>
                    <td class="pl-3">{{ experience.operator }}</td>
                  </tr>
                  <tr>
                    <th>
                      <b> {{ $t("experiment_institution") }}</b>
                    </th>
                    <td class="pl-3">
                      <institutionComponent
                        :isProvided="false"
                        :institution_id="institution.id"
                        :institution_name="institution.name"
                        :institution="institution"
                      ></institutionComponent>
                    </td>
                  </tr>
                </table>
              </div>
              <div
                style="bottom:0"
                class="row align-items-end w-100 md-layout mb-0 pb-0"
              >
                <div class="md-layout-item text-center">
                  <router-link
                    :to="{ name: 'home' }"
                    class="md-button md-info w-100 btn-lg"
                    >{{ $t("back") }}</router-link
                  >
                </div>
                <div class="md-layout-item text-center">
                  <router-link
                    :to="{ name: 'ireal', params: { identifier: experience.identifier } }"
                    class="md-button md-warning w-100 btn-lg"
                    >{{ $t("access") }}</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="/node_modules/videojs-vimeo-v2/src/Vimeo.js"></script>
<script>
// The Root component for viewing informations on IREAL experiment

// @ is an alias to /src
import httpMixin from "ireal-vue/mixins/http-mixin.js";
import videojs from "video.js";
import videoPlayer from "../widgets/VideoPlayer.vue"

export default {
  name: "ireal-detail",
  props: ["identifier"],
  components: {videoPlayer},
  mixins: [httpMixin],
  data() {
    return {
      options: {
        type: Object,
        default() {
          return {};
        }
      },
      source:[],
      experience: undefined,
      institution: [],
      presentation: null,
      // VideoJS player
      player: null,

      // URL of the video
    };
  },
  async created (){
},
  async mounted() {
      this.experience = await this.getExperience(this.identifier);
      this.institution = await this.getObject(
        "institution",
        this.experience.institution.institution
      )
     // this.experience.description != "pas de description"
      //  ? (this.presentation = this.experience.description)
      //  : "";
      this.presentation = this.experience.description
      this.presentation = JSON.parse(this.presentation);
      // var video = videojs("myDIV", {
      //   children: {
      //     controlBar: {
      //       children: {
      //         volumeControl: false
      //       }
      //     }
      //   }
      // });
    this.source.push(this.presentation.Presentation)
      this.sourcev()
    this.player = videojs(this.$refs.myVideo, {
        controls: true,
        fluid: true
      });
      this.player.src({
      
        type: "video/mp4",
        src: this.source[0]
      });
      
      console.log(this.source)
  },
  methods: {
    async load() {
      this.experience = await this.getExperience(this.identifier);
      this.institution = await this.getObject(
        "institution",
        this.experience.institution.id
      )
      this.experience.description != "pas de description"
        ? (this.presentation = this.experience.description)
        : "";
      this.presentation = JSON.parse(this.presentation);
      // var video = videojs("myDIV", {
      //   children: {
      //     controlBar: {
      //       children: {
      //         volumeControl: false
      //       }
      //     }
      //   }
      // });
    this.source.push(this.presentation.Presentation)
      this.sourcev()
    },
    play_video() {
      this.player.play();
    }
  },
  update(){
       
    },
  computed:{
sourcev(){

return this.source
  },
}
};
</script>

<style scoped>
  @import 'https://vjs.zencdn.net/7.17.0/video-js.css';
.credits {
  font-size: 12px;
}
.controlBar {
  display: block !important;
}
.colored-shadow {
  min-height: auto;
}
.controls {
   width:100%;
   height:8.0971659919028340080971659919028%; /* of figure's height */
   position:relative;
}
.controls[data-state=hidden] {
   display:block;
}

.controls[data-state=visible] {
   display:block;
}
</style>
